import React from 'react';

const DailyImageCell = ({ imageUrl, isVisible, isArmed, onToggle }) => {
  const normalizedImageUrl = typeof imageUrl === 'string' ? imageUrl.trim() : '';
  if (!normalizedImageUrl) return '-';

  const title = isVisible
    ? 'Click to hide image'
    : isArmed
      ? 'Click again to reveal image'
      : 'Click once to prepare reveal';

  return (
    <button
      type="button"
      className={`daily-admin-image-toggle${isVisible ? ' is-revealed' : ''}${isArmed ? ' is-armed' : ''}`}
      onClick={onToggle}
      title={title}
      aria-label={title}
    >
      {isVisible ? (
        <>
          <img src={normalizedImageUrl} alt="Daily puzzle preview" className="daily-admin-preview" />
          <span className="daily-admin-image-toggle__hint">Click to hide</span>
        </>
      ) : isArmed ? (
        'Click again to reveal'
      ) : (
        'Hidden'
      )}
    </button>
  );
};

export default DailyImageCell;
